// extracted by mini-css-extract-plugin
export default {"ContainerExterno":"Index_ContainerExterno__pRbw-","Container":"Index_Container__NPQ1M","BannerDuvidas":"Index_BannerDuvidas__2JIJp","BannerTextos":"Index_BannerTextos__I-Ipk"};